import {makeStyles} from "@material-ui/core";

export default function EtiquetasListaCss() {
    return makeStyles(theme => ({
        root: {
            marginTop: 20
        },
    }));
}